// component block
import { useSearchParams } from "react-router-dom";
import { AuthLayout } from "../../../components/auth/Layout";
import { SetPasswordForm } from "../../../components/auth/SetPasswordForm";
import { SET_PASSWORD, SET_PASSWORD_SUBTITLE } from "../../../constants";

export const SetPassword = (): JSX.Element => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  return (
    <AuthLayout title={SET_PASSWORD} subTitle={SET_PASSWORD_SUBTITLE}>
      <SetPasswordForm token={token || ""} />
    </AuthLayout>
  )
}